import axios, {
  type AxiosInstance,
  type InternalAxiosRequestConfig,
  type AxiosResponse,
} from 'axios'
import { getUrlConfig } from '../utils/url'

function getApiBaseUrl(): string {
  const { isSubdomain, mainAppUrl } = getUrlConfig()

  // If on a profile subdomain, API calls go to main domain
  if (isSubdomain) {
    return `${mainAppUrl}/api/v1`
  }

  // On main domain, use relative path
  return '/api/v1'
}

const api: AxiosInstance = axios.create({
  baseURL: getApiBaseUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
})

// Request interceptor to add auth tokens
api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const accessToken = localStorage.getItem('access-token')
  const client = localStorage.getItem('client')
  const uid = localStorage.getItem('uid')

  if (accessToken && client && uid) {
    config.headers['access-token'] = accessToken
    config.headers['client'] = client
    config.headers['uid'] = uid
  }

  return config
})

// Response interceptor to store new tokens
api.interceptors.response.use((response: AxiosResponse) => {
  const accessToken = response.headers['access-token']
  const client = response.headers['client']
  const uid = response.headers['uid']

  if (accessToken) {
    localStorage.setItem('access-token', accessToken)
  }
  if (client) {
    localStorage.setItem('client', client)
  }
  if (uid) {
    localStorage.setItem('uid', uid)
  }

  return response
})

export default api
